import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChargeExceptionnelle } from '@model/syndic/charge-exceptionnelle';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { ChargeExceptionnelleService } from '@service/syndic/charge-exceptionnelle.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-charge-exceptionnelle-add',
  templateUrl: './charge-exceptionnelle-add.component.html',
  styleUrls: ['./charge-exceptionnelle-add.component.scss']
})
export class ChargeExceptionnelleAddComponent implements OnInit {

  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  charge: ChargeExceptionnelle;
  title: string = '';
  houseCoUuid: string = '';

  modesRepartition = [
    { label: 'Par tantièmes', value: 'TANTIEMES' },
    { label: 'Montant fixe', value: 'FIXE' }
  ];

  recurrences = [
    { label: 'Unique', value: 'UNIQUE' },
    { label: 'Mensuel', value: 'MENSUEL' },
    { label: 'Trimestriel', value: 'TRIMESTRIEL' },
    { label: 'Annuel', value: 'ANNUEL' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private chargeService: ChargeExceptionnelleService
  ) {
    this.edit = this.chargeService.edit;
    this.charge = this.chargeService.getChargeExceptionnelle();
    this.houseCoUuid = this.chargeService.houseCoUuid;
    const nom = this.charge ? this.charge.nom : '';
    this.title = (!this.edit) ? 'Ajouter une charge exceptionnelle' : 'Modifier la charge ' + nom;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.charge) {
      this.setFormValue();
    }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      nom: [null, [Validators.required]],
      description: [null],
      modeRepartition: ['TANTIEMES'],
      montantFixe: [0],
      montantTotal: [0, [Validators.required]],
      recurrence: ['UNIQUE'],
      dateDebut: [null],
      dateFin: [null],
      actif: [true],
      houseCo: [this.houseCoUuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.charge.uuid,
      nom: this.charge.nom,
      description: this.charge.description,
      modeRepartition: this.charge.modeRepartition,
      montantFixe: this.charge.montantFixe,
      montantTotal: this.charge.montantTotal,
      recurrence: this.charge.recurrence,
      dateDebut: this.charge.dateDebut,
      dateFin: this.charge.dateFin,
      actif: this.charge.actif,
      houseCo: this.charge.houseCo?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.chargeService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'CHARGE_EXCEPTIONNELLE_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'CHARGE_EXCEPTIONNELLE_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void {
    this.modal.close('ferme');
  }

  get f() { return this.form.controls; }
}
